import type { IssueParent } from '../../../../model/issue-parent/types';

export const LOAD_ISSUE_PARENTS_SUCCESS = 'state.actions.app.LOAD_ISSUE_PARENTS_SUCCESS' as const;

export interface LoadIssueParentsSuccessAction {
	type: typeof LOAD_ISSUE_PARENTS_SUCCESS;
	payload: {
		issueParents: IssueParent[];
	};
}

export const loadIssueParentsSuccess = (
	issueParents: IssueParent[],
): LoadIssueParentsSuccessAction => ({
	type: LOAD_ISSUE_PARENTS_SUCCESS,
	payload: { issueParents },
});

export const LOAD_ISSUE_PARENTS_FAILURE = 'state.actions.app.LOAD_ISSUE_PARENTS_FAILURE' as const;

export interface LoadIssueParentsFailureAction {
	type: typeof LOAD_ISSUE_PARENTS_FAILURE;
}

export const loadIssueParentsFailure = (): LoadIssueParentsFailureAction => ({
	type: LOAD_ISSUE_PARENTS_FAILURE,
});

export type Action = LoadIssueParentsSuccessAction | LoadIssueParentsFailureAction;
